/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('account', [
  'basic',
  'changePassword',
  'reactivate',
  'updateBasic',
  'forgetPassword',
]);

function basic() {
  return createAPIAction(
    types.basic,
    {
      endpoint: '/account/basic',
      method: 'GET',
    })();
}

function updateBasic(data) {
  return createAPIAction(
    types.updateBasic,
    {
      endpoint: '/account/basic',
      method: 'PUT',
      body: data,
    },
  )();
}

function changePassword(oldPassword, newPassword) {
  return createAPIAction(
    types.changePassword,
    {
      endpoint: '/account/password',
      method: 'PUT',
      body: { oldPassword, newPassword },
    },
  )();
}

function forgetPassword(email, key, verifyCode, ref) {
  return createAPIAction(
    types.forgetPassword,
    {
      endpoint: '/account/forget',
      method: 'POST',
      body: {
        email,
        key,
        verifyCode,
        ref,
      },
    },
  )();
}

function reactivate(email) {
  return createAPIAction(
    types.reactivate,
    {
      endpoint: '/account/reactivate',
      method: 'POST',
      body: {
        ref: 'lora',
        email,
      },
    })();
}

export default {
  basic,
  changePassword,
  reactivate,
  updateBasic,
  forgetPassword,
};




// WEBPACK FOOTER //
// ./src/redux/actions/account.js